import { render, staticRenderFns } from "./order-reception.vue?vue&type=template&id=60c6693c&scoped=true&"
import script from "./order-reception.vue?vue&type=script&lang=js&"
export * from "./order-reception.vue?vue&type=script&lang=js&"
import style0 from "./order-reception.vue?vue&type=style&index=0&id=60c6693c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6693c",
  null
  
)

export default component.exports